import { useContent } from "../../../context/ContentContext";
import { Editable } from "../../../context/design";

export default function FooterSection() {
  const { footer } = useContent();

  return (
    <footer className="relative w-full bg-sky-900 text-white">
      <div className="absolute inset-0 overflow-hidden opacity-5">
        <svg className="absolute -right-20 -top-20 w-96 h-96" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
          <path fill="currentColor" d="M44.7,-76.4C58.9,-69.2,71.8,-59.1,81.6,-46.6C91.4,-34.1,98.1,-19.2,95.8,-5.3C93.5,8.6,82.2,21.5,71.6,32.3C61,43.1,51.1,51.8,40.3,59.5C29.5,67.2,17.8,73.9,5.3,75.5C-7.2,77.1,-20.5,73.6,-32.7,67.1C-44.9,60.6,-56,51.1,-65.3,39.7C-74.6,28.3,-82.1,15,-81.3,2.1C-80.5,-10.8,-71.4,-23.3,-61.4,-33.8C-51.4,-44.3,-40.5,-52.8,-28.8,-61.3C-17.1,-69.8,-4.6,-78.3,8.3,-91.3L21.2,-104.3" transform="translate(100 100)" />
        </svg>
      </div>

      <div className="relative z-10 w-full px-4 sm:px-6 lg:px-12 xl:px-20 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-8">
          <div className="lg:col-span-2">
            <a href="#hero" className="inline-block text-2xl font-semibold mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
              <Editable as="span" id="footer.brand" label="Markenname">{footer.brand}</Editable><span className="text-sky-400">.</span>
            </a>
            <Editable as="p" id="footer.description" label="Kurzbeschreibung" className="text-sky-200/80 leading-relaxed max-w-md mb-6">{footer.description}</Editable>
            <div className="flex items-center gap-3">
              <a href={footer.instagram_url} className="w-10 h-10 rounded-lg border border-sky-700 flex items-center justify-center text-sky-300 hover:bg-sky-800 hover:text-white transition-colors" aria-label="Instagram">
                <i className="ri-instagram-line"></i>
              </a>
              <a href={footer.facebook_url} className="w-10 h-10 rounded-lg border border-sky-700 flex items-center justify-center text-sky-300 hover:bg-sky-800 hover:text-white transition-colors" aria-label="Facebook">
                <i className="ri-facebook-line"></i>
              </a>
              <a href={footer.linkedin_url} className="w-10 h-10 rounded-lg border border-sky-700 flex items-center justify-center text-sky-300 hover:bg-sky-800 hover:text-white transition-colors" aria-label="LinkedIn">
                <i className="ri-linkedin-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-sky-200 mb-4">Navigation</h4>
            <ul className="space-y-3">
              {[["about","Über den Workshop"],["features","Was dich erwartet"],["target","Für wen"],["details","Details"],["cta","Anmelden"]].map(([id, label]) => (
                <li key={id}><a href={`#${id}`} className="text-sky-300/80 hover:text-white transition-colors text-sm">{label}</a></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-sky-200 mb-4">Kontakt</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-sky-300/80 text-sm"><i className="ri-mail-line text-sky-400"></i><Editable as="span" id="footer.email" label="E-Mail">{footer.email}</Editable></li>
              <li className="flex items-center gap-2 text-sky-300/80 text-sm"><i className="ri-phone-line text-sky-400"></i><Editable as="span" id="footer.phone" label="Telefon">{footer.phone}</Editable></li>
              <li className="flex items-center gap-2 text-sky-300/80 text-sm"><i className="ri-map-pin-line text-sky-400"></i><Editable as="span" id="footer.location" label="Standort">{footer.location}</Editable></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-sky-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-sky-400/60">&copy; 2026 Einsam – echt – verbunden. Alle Rechte vorbehalten.</p>
            <div className="flex items-center gap-6">
              <a href={footer.impressum_url} className="text-xs text-sky-400/60 hover:text-sky-300 transition-colors">Impressum</a>
              <a href={footer.datenschutz_url} className="text-xs text-sky-400/60 hover:text-sky-300 transition-colors">Datenschutz</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
